var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 62,
    viewBox: "0 0 91 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2929 31.7071C24.9024 31.3166 24.9024 30.6834 25.2929 30.2929L31.6569 23.9289C32.0474 23.5384 32.6805 23.5384 33.0711 23.9289C33.4616 24.3195 33.4616 24.9526 33.0711 25.3431L27.4142 31L33.0711 36.6569C33.4616 37.0474 33.4616 37.6805 33.0711 38.0711C32.6805 38.4616 32.0474 38.4616 31.6569 38.0711L25.2929 31.7071ZM68 32H26V30H68V32Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 90,
    height: 61,
    transform: "matrix(-1 0 0 1 90 0)",
    stroke: "black",
    strokeOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnarrow);
export default __webpack_public_path__ + "static/media/btnarrow.41251bc4e2ae2449146ddb9674e0f463.svg";
export { ForwardRef as ReactComponent };